import axios from 'axios';
import ConstantApi from '../../../../ConstantApi';
import axiosCall from '../../../axiosCall';
import { fetchPartyDetailsData } from '../../../partyDetails/partyDetails.action';
import { fetchCommonPropertyById } from '../../../property/common/commonProperty.actions';
import { fetchSeasonMaster } from '../../../seasonMaster/seasonMaster.actions';
import { fetchUnitMaster } from '../../../unitMaster/unitMaster.actions';
import {
    fetchSupplierListBasedOnProgramDC,
    fetchYarnPOProgramDropdown,
    fetchYarnPOSalesOrderDropdown,
    fetchYarnPOSupplierDropdown2,
    getYarnLotNoInvoiceData,
    getYarnPOInvoiceDataV2
} from '../../YarnPO/yarnPO/yarnPO.actions';
import {
    CREATE_KNITTING_DC_FAILURE,
    CREATE_KNITTING_DC_REQUEST,
    CREATE_KNITTING_DC_SUCCESS,
    CREATE_USER_FORM_KNITTING_DC,
    DELETE_KNITTING_DC_FAILURE,
    DELETE_KNITTING_DC_REQUEST,
    DELETE_KNITTING_DC_SUCCESS,
    FETCH_SINGLE_KNITTING_DC_FAILURE,
    FETCH_SINGLE_KNITTING_DC_REQUEST,
    FETCH_SINGLE_KNITTING_DC_SUCCESS,
    FETCH_KNITTING_DC_FAILURE,
    FETCH_KNITTING_DC_REQUEST,
    FETCH_KNITTING_DC_SUCCESS,
    KNITTING_DC_USERFORM_RESET,
    UPDATE_KNITTING_DC_FAILURE,
    UPDATE_KNITTING_DC_REQUEST,
    UPDATE_KNITTING_DC_SUCCESS,
    KNITTING_DC_USERFORM_NAVIGATE_TO_DETAIL_TAB,
    FETCH_YARN_PO_IN_KNITTING_DC_REQUEST,
    FETCH_YARN_PO_IN_KNITTING_DC_SUCCESS,
    FETCH_YARN_PO_IN_KNITTING_DC_FAILURE,
    FETCH_KNITTING_DC_INVOICE_REQUEST,
    FETCH_KNITTING_DC_INVOICE_SUCCESS,
    FETCH_KNITTING_DC_INVOICE_FAILURE,
    FETCH_KNITTING_DC_DETAILS_RATE_FROM_STYLE_REQUEST,
    FETCH_KNITTING_DC_DETAILS_RATE_FROM_STYLE_SUCCESS,
    FETCH_KNITTING_DC_DETAILS_RATE_FROM_STYLE_FAILURE,
    CHECK_ALL_UPDATE_REQUEST_KNITTING,
    CHECK_ALL_UPDATE_SUCCESS_KNITTING,
    CHECK_ALL_UPDATE_FALIURE_KNITTING,
    CLOSE_BTN_POST_REQUEST_KNITTING,
    CLOSE_BTN_POST_SUCCESS_KNITTING,
    CLOSE_BTN_POST_FALIURE_KNITTING,
    FETCH_KNITTING_DC_DETAILS_PRINT_SECOND_GRID_STYLE_REQUEST,
    FETCH_KNITTING_DC_DETAILS_PRINT_SECOND_GRID_STYLE_SUCCESS,
    FETCH_KNITTING_DC_DETAILS_PRINT_SECOND_GRID_STYLE_FAILURE
} from './knittingDC.actionsType';
import Config from '../../../../config';
import Cookies from 'js-cookie';

// FETCH PROPERTY MASTER
export let fetchKnittingDC = (startDate, endDate, unitId) => {
    let config = {
        method: 'get',
        // url: `${ConstantApi.knittingDCMasterGET}`,
        url: `${ConstantApi.knittingDCMasterGET}?fromDate=${startDate}&toDate=${endDate}&FldFKUnitId=${-1}`,
        responseTypeRequest: FETCH_KNITTING_DC_REQUEST,
        responseTypeSuccess: FETCH_KNITTING_DC_SUCCESS,
        responseTypeFailure: FETCH_KNITTING_DC_FAILURE
    };
    return axiosCall(config);
};

// create user Form
export let createKnittingDCUserForm = (key, value) => {
    return (dispatch) => {
        dispatch({ type: CREATE_USER_FORM_KNITTING_DC, payload: { key, value } });
    };
};

// CREATE PROPERTY MASTER
export let createKnittingDC = (formData, modalClose, startDate, endDate, isDetail, userform, unitId) => {
    let today = new Date();
    let data = JSON.stringify({
        fldId: 0,
        fldFKSupplierID: parseInt(userform?.fldFKSupplierID),
        fldFKTypeofPO: parseInt(formData.fldFKTypeofPO),
        fldFKSource: parseInt(formData.fldFKSource),
        fldFKSeason: parseInt(formData.fldFKSeason),
        fldFKDepartment: 1 || parseInt(formData.fldFKDepartment),
        fldFKSaleOrderdetail: parseInt(formData.fldFKSaleOrderdetail),
        fldDCNo: 'Auto Generated',
        fldDCDate: today.toISOString(),
        fldDeliveryStartDate: formData.fldDeliveryStartDate || today.toISOString(),
        fldDeliveryEndDate: formData.fldDeliveryEndDate || today.toISOString(),
        fldIsInHouseProduction: formData.fldIsInHouseProduction,
        fldIsInHouseDelivery: formData.fldIsInHouseDelivery,
        // fldFKDeliveryAt: formData.fldIsInHouseDelivery ? 0 : parseInt(userform?.fldFKDeliveryAt),
        fldFKDeliveryAt: parseInt(userform.fldFKDeliveryAt),
        fldNoofBags: Number(formData.fldNoofBags),
        fldTotalQty: Number(formData.fldTotalQty),
        fldInwardQty: 0,
        fldCancelQty: 0,
        fldBalanceQty: 0,

        fldPreparedBy: formData.fldPreparedBy,
        fldPrepareDate: formData.fldPrepareDate,
        fldVerifyBy: formData.fldVerifyBy,
        fldVerifyDate: formData.fldVerifyDate,
        fldAuthorizeBy: formData.fldAuthorizeBy,
        fldAuthorizeDate: formData.fldAuthorizeDate,

        // fldPreparedBy: '',
        // fldPrepareDate: today.toISOString(),
        // fldVerifyBy: '',
        // fldVerifyDate: today.toISOString(),
        // fldAuthorizeBy: '',
        // fldAuthorizeDate: today.toISOString(),
        fldInwardBy: '',
        fldInwardDate: today.toISOString(),
        fldRemarks: formData.fldRemarks,
        fldIsActive: true,
        fldEnteredSysId: formData.ipv4,
        fldCreatedBy: 11,
        fldCreatedDt: today.toISOString(),
        fldFKStatus: formData.fldFKStatus,
        fldFKUnitId: parseInt(formData.fldFKUnitId),
        fldFKSection: parseInt(formData.fldFKSection),
        fldFKProgram: parseInt(formData.fldFKProgram),
        fldApprovalStatus: 0,
        fldUnitCode: '',
        fldUnitName: '',
        fldUnitAddress1: '',
        fldUnitAddress2: '',
        fldUnitFKArea: 0,
        fldUnitCountry: '',
        fldUnitState: '',
        fldUnitCity: '',
        fldUnitArea: '',
        fldUnitPincode: '',
        fldUnitGSTNo: '',
        fldSupplierCode: '',
        fldSupplierName: '',
        fldSupplierAddress1: '',
        fldSupplierAddress2: '',
        fldSupplierFKArea: 0,
        fldSupplierCountry: '',
        fldSupplierState: '',
        fldSupplierCity: '',
        fldSupplierArea: '',
        fldSupplierPincode: '',
        fldSupplierGSTNo: '',
        fldDeliveryAtCode: '',
        fldDeliveryAtName: '',
        fldDeliveryAtAddress1: '',
        fldDeliveryAtAddress2: '',
        fldDeliveryAtFKArea: 0,
        fldDeliveryAtCountry: '',
        fldDeliveryAtState: '',
        fldDeliveryAtCity: '',
        fldDeliveryAtArea: '',
        fldDeliveryAtPincode: '',
        fldDeliveryAtGSTNo: '',
        fldFKSaleOrder: parseInt(formData.fldFKSaleOrder),
        fldFKStyle: parseInt(userform.fldFKStyle),
        fldFKMainstyle: parseInt(userform.fldFKMainstyle),
        fldItemsGrossValue: Number(formData.fldItemsGrossValue),
        fldItemsTaxableValue: Number(formData.fldItemsTaxableValue),
        fldItemsGSTValue: Number(formData.fldItemsGSTValue),
        fldItemsTotalValue: Number(formData.fldItemsTotalValue),
        fldDiscountPercentage: Number(formData.fldDiscountPercentage),
        fldDiscountValue: Number(formData.fldDiscountValue),
        fldGrandGrossValue: Number(formData.fldGrandGrossValue),
        fldOtherPlusValue: Number(formData.fldOtherPlusValue),
        fldOtherMinusValue: Number(formData.fldOtherMinusValue),
        fldRoundoff: Number(formData.fldRoundoff),
        fldGrandTotalValue: Number(formData.fldGrandTotalValue),
        FldFKPaymentTerms: parseInt(formData.fldFKPaymentTerms)
    });
    let config = {
        method: 'post',
        data,
        url: `${ConstantApi.knittingDCMasterPOST}`,
        responseTypeRequest: CREATE_KNITTING_DC_REQUEST,
        responseTypeSuccess: CREATE_KNITTING_DC_SUCCESS,
        responseTypeFailure: CREATE_KNITTING_DC_FAILURE,
        resetFormData: isDetail ? KNITTING_DC_USERFORM_NAVIGATE_TO_DETAIL_TAB : KNITTING_DC_USERFORM_RESET,
        modalClose,
        PoDcInwardNo: 'fldPONO',
        PoDcInwardType: 'DC',
        isPopupOpen: true,
        headers: {
            'Content-Type': 'application/json'
        },
        getAllData: fetchKnittingDC(startDate, endDate, unitId)
    };
    return axiosCall(config);
};

// GET SINGLE PROPERTY MASTER
export let getSingleKnittingDC = (id) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.knittingDCMasterGETID}/${id}`,
        responseTypeRequest: FETCH_SINGLE_KNITTING_DC_REQUEST,
        responseTypeSuccess: FETCH_SINGLE_KNITTING_DC_SUCCESS,
        responseTypeFailure: FETCH_SINGLE_KNITTING_DC_FAILURE,
        singlApiArray: [
            // fetchSeasonMaster(),
            // fetchPartyDetailsData(),
            // fetchCommonPropertyById(52),
            // fetchCommonPropertyById(46),
            // fetchCommonPropertyById(28),
            // fetchUnitMaster(),
            // fetchYarnPOProgramDropdown('TblKnittingDC'),
            // fetchSupplierListBasedOnProgramDC('TblKnittingDC'),
            // fetchYarnPOSupplierDropdown2('TblProgramSupplier')
        ]
    };
    return axiosCall(config);
};

export let getKnittingDCInvoiceDataV2 = (id) => {
    // let config = {
    //     method: 'get',
    //     url: `${ConstantApi.knittingDCInvoiceGET}/${id}`,
    //     responseTypeRequest: FETCH_KNITTING_DC_INVOICE_REQUEST,
    //     responseTypeSuccess: FETCH_KNITTING_DC_INVOICE_SUCCESS,
    //     responseTypeFailure: FETCH_KNITTING_DC_INVOICE_FAILURE
    // };
    // return axiosCall(config);
    return (dispatch) => {
        dispatch({ type: FETCH_KNITTING_DC_INVOICE_REQUEST });
        var config = {
            method: 'get',
            url: `${Config.baseUrl}${ConstantApi.knittingDCInvoiceGET}/${id}`,
            headers: {
                // 'Access-Control-Allow-Origin': true,
                'Content-Type': 'application/json',
                Authorization: `Bearer ${Cookies.get('JWT_TOKEN')}`,
                dbname: Cookies.get('DATABASE')
            }
        };

        axios(config)
            .then((response) => {
                dispatch({ type: FETCH_KNITTING_DC_INVOICE_SUCCESS, updatePayload: response.data });

                //dispatch(getYarnPOInvoiceDataV2(response?.data[0]?.fldFkYarnPO,'YAI'));
                // dispatch(getYarnLotNoInvoiceData(response?.data[0]?.FldFKStyleNumber));
            })
            .catch((error) => {
                dispatch({ type: FETCH_KNITTING_DC_INVOICE_FAILURE, updatePayload: error });
            });
    };
};

export let fetchKnittingDCDetailsRatePrKgFrmStyle = (style, fabGrp, yarnCnt, fabric, dia, fldId) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.knittingDCDetailsRatePrKgFrmStyleGET}?FldFKStyle=${style}&FabGrp=${fabGrp}&YarnCnt=${yarnCnt}&Fab=${fabric}&Dia=${dia}&fldId=${fldId}`,
        responseTypeRequest: FETCH_KNITTING_DC_DETAILS_RATE_FROM_STYLE_REQUEST,
        responseTypeSuccess: FETCH_KNITTING_DC_DETAILS_RATE_FROM_STYLE_SUCCESS,
        responseTypeFailure: FETCH_KNITTING_DC_DETAILS_RATE_FROM_STYLE_FAILURE
    };
    return axiosCall(config);
};

//UPDATE PROPERTY MASTER
export let updateKnittingDC = (formData, id, startDate, endDate, userform, unitId) => {
    let today = new Date();
    let data = JSON.stringify({
        fldId: parseInt(id),
        fldFKSupplierID: parseInt(userform?.fldFKSupplierID),
        fldFKTypeofPO: parseInt(formData.fldFKTypeofPO),
        fldFKSource: parseInt(formData.fldFKSource),
        fldFKSeason: parseInt(formData.fldFKSeason),
        fldFKDepartment: 1 || parseInt(formData.fldFKDepartment),
        fldDCNo: formData?.fldDCNo,
        fldDCDate: formData?.fldDCDate,
        fldDeliveryStartDate: formData.fldDeliveryStartDate,
        fldFKSaleOrderdetail: parseInt(formData.fldFKSaleOrderdetail),
        fldDeliveryEndDate: formData.fldDeliveryEndDate,
        fldIsInHouseProduction: formData.fldIsInHouseProduction,
        fldIsInHouseDelivery: formData.fldIsInHouseDelivery,
        // fldFKDeliveryAt: formData.fldIsInHouseDelivery ? 0 : parseInt(userform.fldFKDeliveryAt),
        fldFKDeliveryAt: parseInt(userform.fldFKDeliveryAt),
        fldNoofBags: parseInt(formData.fldNoofBags),
        fldTotalQty: parseInt(formData.fldTotalQty),
        fldInwardQty: formData?.fldInwardQty,
        fldCancelQty: formData?.fldCancelQty,
        fldBalanceQty: formData?.fldBalanceQty,

        fldVerifyBy: formData.fldVerifyBy,
        fldVerifyDate: formData.fldVerifyDate,
        fldAuthorizeBy: formData.fldAuthorizeBy,
        fldAuthorizeDate: formData.fldAuthorizeDate,

        // fldVerifyBy: '',
        // fldVerifyDate: today.toISOString(),
        // fldAuthorizeBy: '',
        // fldAuthorizeDate: today.toISOString(),
        fldInwardBy: '',
        fldInwardDate: today.toISOString(),
        fldRemarks: formData.fldRemarks,
        fldIsActive: true,
        fldEnteredSysId: formData.ipv4,
        fldCreatedBy: formData.fldCreatedBy,
        fldCreatedDt: formData.fldCreatedDt,
        fldPreparedBy: formData.fldPreparedBy,
        fldPrepareDate: formData.fldPrepareDate,
        fldModifiedBy: 11,
        fldModifiedDt: today.toISOString(),
        fldFKStatus: formData.fldFKStatus,
        fldFKUnitId: parseInt(formData.fldFKUnitId),
        fldFKSection: parseInt(formData.fldFKSection),
        fldFKProgram: parseInt(formData.fldFKProgram),
        fldApprovalStatus: 0,
        fldUnitCode: '',
        fldUnitName: '',
        fldUnitAddress1: '',
        fldUnitAddress2: '',
        fldUnitFKArea: 0,
        fldUnitCountry: '',
        fldUnitState: '',
        fldUnitCity: '',
        fldUnitArea: '',
        fldUnitPincode: '',
        fldUnitGSTNo: '',
        fldSupplierCode: '',
        fldSupplierName: '',
        fldSupplierAddress1: '',
        fldSupplierAddress2: '',
        fldSupplierFKArea: 0,
        fldSupplierCountry: '',
        fldSupplierState: '',
        fldSupplierCity: '',
        fldSupplierArea: '',
        fldSupplierPincode: '',
        fldSupplierGSTNo: '',
        fldDeliveryAtCode: '',
        fldDeliveryAtName: '',
        fldDeliveryAtAddress1: '',
        fldDeliveryAtAddress2: '',
        fldDeliveryAtFKArea: 0,
        fldDeliveryAtCountry: '',
        fldDeliveryAtState: '',
        fldDeliveryAtCity: '',
        fldDeliveryAtArea: '',
        fldDeliveryAtPincode: '',
        fldDeliveryAtGSTNo: '',
        fldFKSaleOrder: parseInt(userform.fldFKSaleOrder),
        fldFKStyle: parseInt(userform.fldFKStyle),
        fldFKMainstyle: parseInt(userform.fldFKMainstyle),
        fldItemsGrossValue: formData.fldItemsGrossValue ? Number(formData.fldItemsGrossValue) : 0,
        fldItemsTaxableValue: formData.fldItemsTaxableValue ? Number(formData.fldItemsTaxableValue) : 0,
        fldItemsGSTValue: formData.fldItemsGSTValue ? Number(formData.fldItemsGSTValue) : 0,
        fldItemsTotalValue: formData.fldItemsTotalValue ? Number(formData.fldItemsTotalValue) : 0,
        fldDiscountPercentage: formData.fldDiscountPercentage ? Number(formData.fldDiscountPercentage) : 0,
        fldDiscountValue: formData.fldDiscountValue ? Number(formData.fldDiscountValue) : 0,
        fldGrandGrossValue: formData.fldGrandGrossValue ? Number(formData.fldGrandGrossValue) : 0,
        fldOtherPlusValue: formData.fldOtherPlusValue ? Number(formData.fldOtherPlusValue) : 0,
        fldOtherMinusValue: formData.fldOtherMinusValue ? Number(formData.fldOtherMinusValue) : 0,
        fldRoundoff: formData.fldRoundoff ? Number(formData.fldRoundoff) : 0,
        fldGrandTotalValue: formData.fldGrandTotalValue ? Number(formData.fldGrandTotalValue) : 0,

        fldIsPrepared: formData.fldIsPrepared,
        fldIsVerified: formData.fldIsVerified,
        fldIsAuthorized: formData.fldIsAuthorized,
        fldVerifyBy: formData.fldVerifyBy,
        fldVerifyDate: formData.fldVerifyDate,
        fldAuthorizeBy: formData.fldAuthorizeBy,
        fldAuthorizeDate: formData.fldAuthorizeDate,
        FldFKPaymentTerms: parseInt(formData.fldFKPaymentTerms),
    });
    let config = {
        method: 'patch',
        data,
        url: `${ConstantApi.knittingDCMasterPATCH}/${id}`,
        responseTypeRequest: UPDATE_KNITTING_DC_REQUEST,
        responseTypeSuccess: UPDATE_KNITTING_DC_SUCCESS,
        responseTypeFailure: UPDATE_KNITTING_DC_FAILURE,
        // resetFormData: KNITTING_DC_USERFORM_RESET,
        modalClose: true,
        headers: {
            'Content-Type': 'application/json'
        },
        getAllData: fetchKnittingDC(startDate, endDate, unitId)
    };
    return axiosCall(config);
};

// DELETE PROPERTY MASTER
export let deleteKnittingDC = (id, startDate, endDate, unitId) => {
    let config = {
        method: 'delete',
        url: `${ConstantApi.knittingDCMasterDELETE}/${id}`,
        responseTypeRequest: DELETE_KNITTING_DC_REQUEST,
        responseTypeSuccess: DELETE_KNITTING_DC_SUCCESS,
        responseTypeFailure: DELETE_KNITTING_DC_FAILURE,
        modalClose: true,
        getAllData: fetchKnittingDC(startDate, endDate, unitId)
    };
    return axiosCall(config);
};

// FETCH PROPERTY MASTER
export let fetchYarnPOOfPoNo = () => {
    let config = {
        method: 'get',
        url: `${ConstantApi.knittingDCMasterOfYarnPOGET}`,
        responseTypeRequest: FETCH_YARN_PO_IN_KNITTING_DC_REQUEST,
        responseTypeSuccess: FETCH_YARN_PO_IN_KNITTING_DC_SUCCESS,
        responseTypeFailure: FETCH_YARN_PO_IN_KNITTING_DC_FAILURE
    };
    return axiosCall(config);
};

export let updateCheckAllknitting = (id, reason) => {
    let config = {
        method: 'patch',
        url: `${ConstantApi.updateAllCloseIconKnitting}/?FldFKPoNo=${id}&FldReason=${reason?.reason}&IsRollBack=${reason?.checkbox}`,
        responseTypeRequest: CHECK_ALL_UPDATE_REQUEST_KNITTING,
        responseTypeSuccess: CHECK_ALL_UPDATE_SUCCESS_KNITTING,
        responseTypeFailure: CHECK_ALL_UPDATE_FALIURE_KNITTING,
        headers: {
            'Content-Type': 'application/json'
        }
    };
    return axiosCall(config, true);
};

export let PostCloseIconApiKnitting = (id, reason) => {
    let config = {
        method: 'patch',
        url: `${ConstantApi.postCloseIconKNI}?FldId=${id}&FldReason=${reason?.reason}&IsRollBack=${reason?.checkbox}`,
        responseTypeRequest: CLOSE_BTN_POST_REQUEST_KNITTING,
        responseTypeSuccess: CLOSE_BTN_POST_SUCCESS_KNITTING,
        responseTypeFailure: CLOSE_BTN_POST_FALIURE_KNITTING,
        headers: {
            'Content-Type': 'application/json'
        }
    };
    return axiosCall(config, true);
};


export let fetchSecondGridData = (id) => {
    let config = {
        method: 'get',
        url: `${ConstantApi.knittingDCInvoiceGETSecond}/${id}`,
        responseTypeRequest: FETCH_KNITTING_DC_DETAILS_PRINT_SECOND_GRID_STYLE_REQUEST,
        responseTypeSuccess: FETCH_KNITTING_DC_DETAILS_PRINT_SECOND_GRID_STYLE_SUCCESS,
        responseTypeFailure: FETCH_KNITTING_DC_DETAILS_PRINT_SECOND_GRID_STYLE_FAILURE
    };
    return axiosCall(config);
};